import React from 'react';
import { CTAButton } from './CTAButton';
import { Star, Shield, Zap } from 'lucide-react';
const CHECKOUT = 'https://dance-pro.impultienda.ar/checkout';
export function FinalCTA() {
  return <section className="py-8 px-4 sm:px-6 bg-brand-rose text-white border-t-4 border-brand-gold text-center" data-id="element-43">
      <p className="text-xs font-button font-bold text-brand-gold uppercase tracking-widest mb-1.5" data-id="element-44">
        UN'ULTIMA OCCASIONE
      </p>

      <p className="text-sm sm:text-base font-medium mb-4 leading-tight max-w-2xl mx-auto" data-id="element-45">
        Le tue allieve meritano molto più di sessioni improvvisate. Smetti di
        passare ore a creare lezioni ogni settimana, di dubitare delle tue
        decisioni di programmazione e di chiederti se le tue allieve stanno
        progredendo abbastanza velocemente.
        <br data-id="element-46" />
        <br data-id="element-47" />
        <span className="font-bold" data-id="element-48">
          Offri a ogni allieva un'esperienza di danza strutturata, professionale
          e orientata ai risultati. Regalati il sistema di coaching che avresti
          dovuto avere fin dal primo giorno.
        </span>
      </p>

      <div className="bg-white/10 border border-white/20 rounded-lg p-3 mb-4 shadow-md max-w-sm mx-auto" data-id="element-49">
        <p className="text-xs sm:text-sm font-bold mb-0.5 uppercase tracking-wide" data-id="element-50">
          🩰 DANZA READY™ — Box Set Completo 6 in 1 + 5 Bonus Premium
        </p>
        <p className="text-base line-through opacity-70 mb-0.5" data-id="element-51">€97</p>
        <p className="text-3xl font-heading font-bold text-brand-gold leading-none" data-id="element-52">
          Solo: €27
        </p>
      </div>

      <a href={CHECKOUT} target="_blank" rel="noopener noreferrer" className="block cursor-pointer mb-4" data-id="element-53">
        <img src="https://cdn.magicpatterns.com/uploads/2Ypt9z31oa5CZRfZVf6mCK/ChatGPT-Image-23-jun-2026_-10_01_08-p.m..webp" alt="Danza Ready - Box Set Completo 6 in 1" className="w-full max-w-[200px] mx-auto object-contain drop-shadow-xl" data-id="element-54" />
      </a>

      <div className="mb-3" data-id="element-55">
        <CTAButton href={CHECKOUT} className="!bg-brand-gold !text-brand-taupe border-none shadow-[0_4px_14px_0_rgba(212,175,55,0.39)] hover:shadow-[0_6px_20px_rgba(212,175,55,0.23)] hover:!bg-brand-gold/90" data-id="element-56">
          🚀 SÌ, VOGLIO IL MIO PACK DANZA READY™
        </CTAButton>
      </div>

      <div className="flex flex-col sm:flex-row justify-center items-center gap-1 sm:gap-4 text-[10px] sm:text-xs font-bold opacity-90" data-id="element-57">
        <div className="flex items-center gap-1" data-id="element-58">
          <Zap className="w-3.5 h-3.5 text-brand-gold" data-id="element-59" />
          <span data-id="element-60">Accesso Immediato — Consegnato Via Email</span>
        </div>
        <div className="flex items-center gap-1" data-id="element-61">
          <Star className="w-3.5 h-3.5 fill-brand-gold text-brand-gold" data-id="element-62" />
          <span data-id="element-63">4.9/5 — Recensioni Professionali Verificate</span>
        </div>
        <div className="flex items-center gap-1" data-id="element-64">
          <Shield className="w-3.5 h-3.5 text-brand-gold" data-id="element-65" />
          <span data-id="element-66">Garanzia 7 Giorni — Zero Rischio</span>
        </div>
      </div>
    </section>;
}